// extracted by mini-css-extract-plugin
export default {"wrapper":"CardPreview_wrapper__6a6tr","blocked":"CardPreview_blocked__CIPun","multicard":"CardPreview_multicard__-94Os"};